import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Quick Links")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", { href: "contact_us" }, "Contact us", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", { href: "cart" }, "Cart", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", { href: "checkout" }, "Checkout", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", { href: "prescription" }, "Upload Prescription", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!

  return (_openBlock(), _createBlock(_component_ion_list, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_list_header, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, { button: "" }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, { button: "" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, { button: "" }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, { button: "" }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}